import React from 'react';
import './AllseisItem.css'
import '../../gsdecss/gsde.css'

export interface IAllseisPrama {
    name: string | JSX.Element,
    value: string | JSX.Element
}

export interface IAllseis {
    title: string,
    src: string,
    profile: string | JSX.Element,
    bases: IAllseisPrama[],
    detectors: IAllseisPrama[],
    physics: IAllseisPrama[],
}

export function AllseisPrama(props: {
    name: string | JSX.Element,
    value: string | JSX.Element
}) {
    return (
        <div className='gsde-row allseis-prama gsde-center-v'>
            <div className='gsde-col5'>
                <div className="allseis-prama-name">
                    {props.name}
                </div>
            </div>
            <div className='gsde-col7'>
                <div className="allseis-prama-value">
                    {props.value}
                </div>
            </div>
        </div>
    )

}

export function AllseisTable(props: {
    title: string,
    data: IAllseisPrama[],
    className?: string
}) {

    function getPramas() {
        let pramas = [];
        for (let prama of props.data) {
            pramas.push(<AllseisPrama name={prama.name} value={prama.value} />);
        }
        return pramas;
    }

    return (
        <div className={props.className}>
            <div className="allseis-table-title">
                {props.title}
            </div>
            <div className="allseis-table-contents">
                {getPramas()}
            </div>
        </div >
    )
}


export default function AllseisItem(props: {
    data: IAllseis
}) {
    return (
        <div className="gsde-container allseis-item">
            <h1>{props.data.title}</h1>
            <div className='gsde-row'>
                <div className='gsde-col6'>
                    <div>
                        <img className='allseis-img' src={props.data.src ? props.data.src : ""} alt={"ALLSEIS"} />
                    </div>
                    <div className='allseis-profile'>
                        {props.data.profile}
                    </div>
                </div>
                <div className='gsde-col6'>
                    <AllseisTable className="allseis-table" title={"功能概述"} data={props.data.bases} />
                    <AllseisTable className="allseis-table" title={"采集指标"} data={props.data.detectors} />
                    <AllseisTable className="allseis-table" title={"低频检波器指标"} data={props.data.physics} />
                </div>
            </div>
        </div>
    )
}